const Container = ({ fluid, className, children, ...rest}) => {
    return <div className={`${className} mx-auto ${fluid ? 'w-full' : 'w-container'}`} {...rest}>{children}</div>
};

export default Container;